import { useMediaQuery } from '@mui/material';
import { Stack } from '@mui/system';
import React, { useEffect, useState } from 'react'
import { CustomNavbar } from '../../controls/CustomNavbar'
import './home.css'
import { useNavigate } from 'react-router-dom';
import { CheckInOutButtons } from '../../controls/home/CheckInOutButtons';
import { CheckInDetails } from '../../controls/home/CheckInDetails';
import { CurrentDateTime } from '../../controls/home/CurrentDateTime';

export const HomePage = () => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const [isUserCheckedIn, setIsUserCheckedIn] = useState(false);
    const [checkInTime, setCheckInTime] = useState(new Date());
    const isSmallScreen = useMediaQuery('(max-width:500px)');
    const navigate = useNavigate();

    useEffect(() => {
        let lastUpdatedTime = Date.now();
        let requestID = null
        function updateDate() {
            const currentTime = Date.now();
            if (currentTime - lastUpdatedTime >= 1000) {
                setCurrentDate(new Date());
                lastUpdatedTime = currentTime;
            }
            requestID = requestAnimationFrame(updateDate);
        }
        updateDate();
        return () => cancelAnimationFrame(requestID)
    }, []);

    const handleCheckIn = () => {
        setIsUserCheckedIn(true);
        setCheckInTime(new Date());
    }
    const handleCheckOut = () => {
        navigate('/logout')
    }
    return (
        <>
            <CustomNavbar />
            <Stack className='main-container' spacing={7}>
                <CurrentDateTime currentDate={currentDate} />
                <CheckInOutButtons
                    isSmallScreen={isSmallScreen}
                    handleCheckIn={handleCheckIn}
                    handleCheckOut={handleCheckOut}
                    isUserCheckedIn={isUserCheckedIn}
                />
                {isUserCheckedIn ?
                    <CheckInDetails
                        checkInTime={checkInTime}
                    /> : null}
            </Stack>

        </>
    )
}
